<template>
  <WdsStack
    gap-xs
    align-center
    class="tw-max-w-[200px] client-owners-column"
    :data-test="`client-owners-${rowIndex}`"
  >
    <WdsText :text="mainOwner?.label ?? $t('No client owner')" />
    <WdsTooltip v-if="owners.length > 1" :global="tableGlobals">
      <template #tooltip-content>
        <span v-for="(owner, index) in owners" :key="owner.id">
          {{ `${owner.label}${index < owners.length - 1 ? ',' : ''}` }}
          <br />
        </span>
      </template>
      <WdsLabel sm class="tw-whitespace-nowrap" :data-test="`client-owners-${rowIndex}-more`">
        + {{ owners.length - 1 }}
      </WdsLabel>
    </WdsTooltip>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel, WdsStack, WdsText, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'
import { toOwnerSelection } from '@/components/Owners/fragments'

const tableGlobals = useTableGlobalsSelector()

const ClientOwnersColumn = graphql(`
  fragment ClientOwnersColumn on CompanySupplier {
    id
    owners {
      id
      ...OwnerFields
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof ClientOwnersColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(ClientOwnersColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)

const owners = computed(() => column.value.owners.map(toOwnerSelection))
const mainOwner = computed(() => owners.value[0] ?? null)
</script>

<style lang="scss">
.client-owners-column {
  .wds-text {
    @apply tw-truncate;
    .wds-text-primary {
      @apply tw-truncate;
    }
  }
}
</style>
